module.exports = __webpack_public_path__ + "media/images/ver-m-s@2x-da2e4120a061b7a9e291c8f21e075c48.png";